import { CommitWithLookupsSchema, RepoWithLookupsSchema } from '@/types/schema';

export type PromptSelectorProps = (
  | {
      fullInfo: true;
      /**
       * Callback when a prompt is selected.
       * Receives RepoWithLookupsSchema and optional CommitWithLookupsSchema.
       */
      onChange: (
        prompt: RepoWithLookupsSchema,
        commit?: CommitWithLookupsSchema
      ) => void;
    }
  | {
      fullInfo?: false;
      /**
       * Callback when a prompt is selected.
       * Receives a string prompt name.
       */
      onChange: (prompt: string) => void;
    }
) & {
  selectedPromptIdentifier: string | undefined;
  prompt?: RepoWithLookupsSchema;
  tags?: string[];
  className?: string;
  showNewPromptLink?: boolean;
  emptyStateText?: string;
  newPromptText?: string;
  align?: 'center' | 'end' | 'start';
  side?: 'top' | 'right' | 'bottom' | 'left';
  children?: React.ReactNode;
  onSelectNewPrompt?: () => void;
  showCommitSelector?: boolean;
  selectByLatest?: boolean;
  hidePublicPrompts?: boolean;
};

export type TabContentProps = {
  selectedPromptIdentifier?: string;
  selectedCommitHash?: string;
  repos: RepoWithLookupsSchema[];
  isLoading: boolean;
  error: any;
  hasMore: boolean;
  isNextPageLoading: boolean;
  setSize: (size: number | ((size: number) => number)) => void;
  showNewPromptLink?: boolean;
  emptyStateText?: string;
  newPromptText?: string;
  newLink?: string;
  handlePromptSelect: (
    prompt: RepoWithLookupsSchema,
    commit?: CommitWithLookupsSchema
  ) => void;
  showCommitSelector?: boolean;
  searchWithoutTags: boolean;
  setSearchWithoutTags: (searchWithoutTags: boolean) => void;
};

export enum PromptSelectorTab {
  private = 'private',
  public = 'public',
}
